import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orderHistoryClaimApi } from "@/features/my-order/features/order-history/features/claim/api";
import useIdentity from "@/features/ui/hooks/use-identity";
import { companyTypeRequestFormatConverter } from "@/utils/converter";
import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

const useWithdrawClaimDetail = (userRequestDetailId?: number) => {
  const identity = useIdentity();
  const queryClient = useQueryClient();
  const { orderSheetSetId } = useOrderHistoryDetail();
  const { info } = useAppToasts();
  const { tSentence } = useI18nHelper();

  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];
  const companyId = identity?.company?.id;

  const { mutate: withdrawClaimDetail, isPending } = useMutation({
    mutationKey: [
      "order-history",
      "claim",
      orderSheetSetId,
      userRequestDetailId,
    ],
    mutationFn: () => {
      if (
        !orderSheetSetId ||
        !companyType ||
        !companyId ||
        !userRequestDetailId
      ) {
        return Promise.reject(new Error("Missing required parameters"));
      }
      return orderHistoryClaimApi.withdrawClaimDetail(
        companyType,
        companyId,
        orderSheetSetId,
        userRequestDetailId
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          "order-history",
          "claim-list",
          companyType,
          companyId,
          orderSheetSetId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          "order-history",
          "claim-detail",
          companyType,
          companyId,
          orderSheetSetId,
          userRequestDetailId,
        ],
      });

      info(tSentence("order_history:claim.toast_withdraw_success_description"));
    },
  });

  return {
    withdrawClaimDetail,
    isPending,
  };
};

export default useWithdrawClaimDetail;
